// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface IStudioOverallTabState {
  currentTabId: string;
}

type IUpdateCurrentTabIdAction = Action<'updateCurrentTabId'> & IPayload<string>;

export interface IStudioOverallTabIdModel {
  namespace: string;
  state: IStudioOverallTabState;
  effects: {};
  reducers: {
    updateCurrentTabId: Reducer<IStudioOverallTabState, IUpdateCurrentTabIdAction>;
  };
}

export const STUDIO_OVERALL_TAB_ID_MODEL_NAMESPACE = 'dbg-model-studio-overall-tab-id';

const StudioOverallTabIdModel: IStudioOverallTabIdModel = {
  namespace: STUDIO_OVERALL_TAB_ID_MODEL_NAMESPACE,
  state: {
    currentTabId: '',
  },
  effects: {},
  reducers: {
    updateCurrentTabId(state, action) {
      return { ...state, currentTabId: action?.payload || '' };
    },
  },
};

export default StudioOverallTabIdModel;
